import { useQuery } from '@pinia/colada';

import { getReleaseNotes } from '@/apis/queries/releaseNotes';
import { QueryKeys } from '@/shared/queries/keys';

export function useReleaseNotes() {
  const {
    data: notes,
    isLoading,
    error,
  } = useQuery({
    key: QueryKeys.releaseNotes.list(),
    query: async () => {
      const response = await getReleaseNotes();
      return response.items;
    },
  });

  return { notes, isLoading, error };
}
